/**
 * Renders a dropdown menu with a title and links.
 */
import React, { useEffect, useState } from 'react';
import { CSSTransition } from 'react-transition-group';
import ArrowIcon from './ArrowIcon';
import { Link } from 'react-router-dom';
import { useDropdown } from './DropdownContext';
import ExternalIcon from '../core/ExternalLinkIcon';

const DropdownMenu = ({ id, title, links, width, offset }) => {
  const { openDropdown, setOpenDropdown } = useDropdown();
  const isOpen = openDropdown === id;

  const toggleDropdown = () => {
    setOpenDropdown(isOpen ? null : id);
  };

  const handleLinkClick = () => {
    setOpenDropdown(null);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (event.target.closest('.dropdown-menu') === null && !event.target.closest('.relative')) {
        setOpenDropdown(null);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [setOpenDropdown]);

  return (
    <li
      className="relative group"
      onMouseEnter={toggleDropdown}
      onMouseLeave={() => setOpenDropdown(null)}
    >
      <Link
        to="#"
        className="dark:hover:text-dark-5 hover:text-buiha-red py-2 px-4 lg:text-2xl text-xl md:flex hidden items-center font-medium"
        onClick={(e) => {
          e.preventDefault();
          toggleDropdown();
        }}
      >
        {title}
        <ArrowIcon />
      </Link>

      <CSSTransition
        in={isOpen}
        timeout={200}
        classNames="dropdown"
        unmountOnExit
      >
        <div
          className={`dropdown-menu absolute bg-light-1 dark:bg-dark-4 border-2 border-light-3 dark: dark:border-dark-3 py-1 rounded-b-lg z-20 ${width} ${offset}`}
        >
          {links.map((link) => (
            <Link
              key={link.to}
              to={link.to}
              className="block px-2 flex-row flex text-[1.15em] hover-slide"
              onClick={handleLinkClick}
              target={link.external ? '_blank' : '_self'}
            >
              
              {link.label}
              {link.external && <ExternalIcon />}
            </Link>
          ))}
        </div>
      </CSSTransition>
    </li>
  );
};

export default DropdownMenu;
